import React from 'react';
import Popover from '@material-ui/core/Popover';
import { usePopover } from '../Popover/Context';
export function PopoverContent(props) {
  var _usePopover = usePopover(),
      handleClose = _usePopover.handleClose,
      open = _usePopover.open,
      triggerRef = _usePopover.triggerRef;

  return /*#__PURE__*/React.createElement(Popover, Object.assign({
    elevation: 0,
    marginThreshold: 0,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left'
    },
    anchorEl: triggerRef.current,
    open: open,
    onClose: handleClose
  }, props));
}
export default PopoverContent;